import { Grid } from "@material-ui/core";
import { Title } from "App/Component/ui";
import { instance2, STYLE_DEFAULT_MASTER } from "App/constants";
import { defaultToastError, isNull, scrollToTop } from "App/utils/helpers";
import React, { useState } from "react";
import FormUserAccess from "./FormUserAccess";
import { RESET_STATE_USER_ACCESS, useByAccess } from "./helpers";
import TableUserAccess from "./TableUserAccess";
import TransferListUserAccess from "./TransferListUserAccess";

function UserAccess() {
  const classes = STYLE_DEFAULT_MASTER();
  const [formData, setFormData] = useState(RESET_STATE_USER_ACCESS);
  const [rowsUserAccess, setRowsUserAccess] = useState([]);
  const { left, setLeft } = useByAccess(
    formData.access_url,
    formData.access_type_service,
    formData.access_label,
    formData.access_value,
    formData.table,
    formData.user_id
  );

  const fetchDataUserAccess = async () => {
    try {
      const response = await instance2.get(
        "/users_access/daftar_users_access_bulk",
        {
          headers: {
            access_code: formData.access_code,
            role_id: formData.role_id,
          },
        }
      );

      setRowsUserAccess(response.data.body);
    } catch (error) {
      setRowsUserAccess([]);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = (row) => {
    setFormData({
      ...formData,
      user_id: row.user_id,
      user_name: row.username,
      table: row.table,
    });
    scrollToTop();
  };

  // };

  return (
    <div className={classes.root}>
      <Title title='User Access' />

      <FormUserAccess
        formData={formData}
        setFormData={setFormData}
        setRowsUserAccess={setRowsUserAccess}
        fetchDataUserAccess={fetchDataUserAccess}
      />

      {!isNull(formData.access_code) && !isNull(formData.role_id) && (
        <>
          <Grid container>
            <Grid item sm={12}>
              <TransferListUserAccess
                userList={rowsUserAccess}
                formData={formData}
                setFormData={setFormData}
                left={left}
                setLeft={setLeft}
              />
            </Grid>
          </Grid>
          <TableUserAccess
            fetchDataUserAccess={fetchDataUserAccess}
            formData={formData}
            rows={rowsUserAccess}
            handleClickUpdate={handleClickUpdate}
          />
        </>
      )}
    </div>
  );
}

export default UserAccess;
